import { Link } from "react-router-dom";
import TiltContainer from "./common/TiltContainer";

const ProjectCard = ({ title, category, image, link, description, status, index }) => {
    return (
        <TiltContainer className="h-full w-full group select-none overflow-hidden ">
            <Link to={link} className="block h-full relative">
                {/* 1. Main Image Frame - Full Coverage */}
                <div className="absolute inset-0 overflow-hidden bg-tertiary shadow-2xl border border-white/5 z-0 group-hover:border-secondary/30 transition-colors duration-500">
                    <img
                        src={image}
                        alt={title}
                        className="w-full h-full object-cover transition-transform duration-1000 ease-[0.22,1,0.36,1] group-hover:scale-110 group-hover:brightness-75"
                    />
                    {/* Dark gradient for depth */}
                    <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/20 to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-80" />
                </div>

                {/* 2. Floating Info Panel - Overlapping Top Right/Bottom Right */}
                <div className="absolute -bottom-0 -right-20 w-[85%] md:w-[75%] h-[40%] bg-white/95 backdrop-blur-xl border border-primary/10 p-6 md:p-8 z-20 shadow-xl transform translate-y-12 md:translate-y-14 transition-transform duration-500 group-hover:-translate-y-10 group-hover:-translate-x-20">

                    {/* Decor Line */}
                    <div className="absolute top-0 left-8 -translate-y-1/2 w-[1px] h-12 bg-secondary z-30" />

                    <div className="flex flex-col gap-3">
                        <div className="flex justify-between items-start">
                            <div className="space-y-1">
                                <span className="text-[10px] font-bold tracking-[0.25em] text-secondary uppercase block mb-1">
                                    {category}
                                </span>
                                <h3 className="text-xl md:text-2xl font-serif text-primary leading-none">
                                    {title}
                                </h3>
                            </div>
                            <span className="text-primary/20 font-serif italic text-xl">
                                0{index + 1}
                            </span>
                        </div>

                        <div className="h-[1px] w-full bg-primary/10 my-1" />

                        <p className="text-light text-sm font-light leading-relaxed line-clamp-1 mb-2">
                            {description}
                        </p>

                        <div className="flex items-center gap-3 mt-auto text-primary group/btn">
                            <span className="w-8 h-[1px] bg-secondary group-hover/btn:w-12 transition-all duration-300" />
                            <span className="text-[10px] uppercase tracking-widest font-bold">Explore Project</span>
                        </div>
                    </div>
                </div>

                {/* 3. Status Badge - Top Left floating outside */}
                <div className="absolute top-4 -left-2 z-30">
                    <span className="bg-secondary text-primary font-bold text-[10px] px-3 py-1 uppercase tracking-widest shadow-lg transform -rotate-90 origin-bottom-left absolute">
                        {status}
                    </span>
                </div>
            </Link>
        </TiltContainer>
    );
};

export default ProjectCard;
